import { css, html, LitElement } from 'lit';
import { Text } from '../Text/Text';
import '../ContactTile/ContactTile.js';
import '../Chip/Chip.js';
import '../GroupInfo/GroupInfo.js';
import '../Loader/Spinner/Spinner.js';
import '../Placeholder/NoContactsPlaceholder.js';
import { WEB_CONTENT } from '../../../constants/content.js';
class GroupChatContacts extends LitElement {
  static styles = css`
    .searchable-list-topbar svg {
      cursor: pointer;
    }

    ::-webkit-scrollbar {
      width: 5px;
    }

    ::-webkit-scrollbar-track {
      background: transparent;
    }

    ::-webkit-scrollbar-thumb {
      background-color: var(--bg-primary-light) !important;
      border-radius: 10px;
    }

    input {
      border: none;
      outline: none;
      padding: 5px;
      width: 97%;
      background-color: var(--bg-secondary-color);
      color: var(--text-primary-color);
    }

    input::placeholder {
      color: var(--text-primary-color);
    }
    .new-chat-container {
      display: flex;
      flex-direction: column;
      gap: 5px;
      padding: 10px 0;
    }
    .new-chat-topbar {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 20px;
      padding: 10px;
      font-size: var(--title-font-size);
    }
    .new-chat-topbar svg {
      cursor: pointer;
    }
    .new-chat-sidebar-searchbar {
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 5px 10px;
      border-radius: 5px;
      background-color: var(--bg-secondary-color);
      margin: 10px;
    }

    .new-chat-sidebar-searchbar svg {
      width: 20px;
      height: 20px;
    }

    .new-chat-sidebar-body {
      display: flex;
      flex-direction: column;
      width: 100%;
      background-color: var(--bg-primary-color);
      flex-grow: 1;
      overflow-y: auto;
    }
    .new-chat-tile-list {
      width: 100%;
      max-height: 90%;
      overflow-y: auto;
      overflow-x: hidden;
      flex-grow: 1;
    }

    .create-group-button {
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 10px;
      border-radius: 5px;
      background-color: var(--bg-secondary-color);
      margin: 10px;
      cursor: pointer;
      font-size: 18px;
      color: var(--text-primary-color);
    }
    .create-group-button svg {
      background-color: var(--bg-primary-color);
      width: 35px;
      height: 35px;
      padding: 5px;
      border-radius: 50%;
    }

    .selected-contacts {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      padding: 10px 10px;
      margin-bottom: 10px;
      background-color:var(--bg-secondary-color);
    }

    .create-button {
      padding: 10px 20px;
      background-color: var(--base-color);
      color: var(--text-primary-color);
      border: none;
      border-radius: 5px;
      cursor: pointer;
      display: none;
      font-size: var(--text-primary-size);
    }

    .create-button.show {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
      align-self: center;
      width: 90%;
    }

    .group-info-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 25vw;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
      display: flex;
      z-index: 1000;
      transition: transform 0.3s ease;
      transform: translateX(-100%);
    }

    .loading-container {
      width: 100%;
      bottom: 0;
      left: 0;
      background-color: var(--bg-primary-color);
      padding: 10px;
    }

    iso-group-info {
      height: 100%;
      width: 24vw;
    }
    .group-info-overlay.show {
      transform: translateX(0);
    }
    .new-chat-sidebar-searchbar input {
      height: 40px;
      font-size: 1rem;
    }
    .group-info-overlay.hide {
      transform: translateX(-100%);
    }
  `;
  static properties = {
    bgColor: { type: String },
    borderWidth: { type: String },
    borderColor: { type: String },
    borderStyle: { type: String },
    borderRadius: { type: String },
    padding: { type: String },
    height: { type: String },
    width: { type: String },
    label: { type: String },
    fontSize: { type: String },
    fontFamily: { type: String },
    textColor: { type: String },
    contacts: { type: Array },
    closeGroupChatContacts: { type: Function },
    nonBlockedContacts: { type: Array },
    searchQuery: { type: String },
    isNoContactsFound: { type: Boolean },
    selectedContacts: { type: Array },
    showGroupInfo: { type: Boolean },
    selectedUserIds: { type: Array },
    isLoading: { type: Boolean },
    hasSearchQuery: { type: Boolean },
    isGroupCast: { type: Boolean },
  };

  constructor() {
    super();
    this.fontSize = '18px';
    this.bgColor = '#ffffff';
    this.borderWidth = '1px';
    this.borderColor = '#000000';
    this.borderStyle = 'solid';
    this.borderRadius = '5px';
    this.padding = '10px';
    this.height = 'auto';
    this.width = '100%';
    this.label = 'New Chat';
    this.fontFamily = 'Arial, sans-serif';
    this.textColor = '#000000';
    this.searchQuery = '';
    this.debounceTimeout = null;
    this.selectedContacts = [];
    this.showGroupInfo = false;
    this.selectedUserIds = [];
    this.hasSearchQuery = false;
    this.DEBOUNCE_DELAY = 700; // 700ms debounce delay
    this.isGroupCast = false;

    this.addEventListener('create-group-submitted', e => {
      if (e.detail.closeAll) {
        this.closeAll();
      }
    });
  }

  willUpdate(changedProperties) {
    if (changedProperties.has('nonBlockedContacts')) {
      this.isLoading = false;
    }
  }
  render() {
    const svgSize = `calc(${this.fontSize} + 4px)`;
    return this.showGroupInfo
      ? html`
          <iso-group-info
            height="96%"
            width="100%"
            labelFontSize="var(--title-font-size)"
             label=${this.isGroupCast ? "Create New Groupcast" : "Create New Group"}
            padding="8px"
            bgColor="var(--bg-primary-color)"
            textColor="var(--text-primary-color)"
            .selectedUserIds=${this.selectedUserIds}
            .closeGroupInfo=${() => this.closeGroupInfoOverlay()}
            .isGroupCast=${this.isGroupCast}
            .selectedUsers=${this.selectedContacts}
          ></iso-group-info>
        `
      : html`
          <div class="new-chat-container" style="background-color: ${this.bgColor};  height: ${this.height};">
            <div class="new-chat-topbar">
              <svg
                @click=${this.closeGroupChatContacts}
                xmlns="http://www.w3.org/2000/svg"
                height="${svgSize}"
                viewBox="0 -960 960 960"
                width="${svgSize}"
                fill="${this.textColor}"
              >
                <path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z" />
              </svg>
              ${Text({
                content: this.label,
                fontSize: this.fontSize,
                fontFamily: this.fontFamily,
                color: this.textColor,
              })}
            </div>
            <div class="new-chat-sidebar-body">
              <div class="new-chat-sidebar-searchbar">
                <input id="search-input" placeholder="${WEB_CONTENT.PLACEHOLDER_CONTENT.SEARCH_FOR_NAME_OR_NUMBER}" @input="${this.handleInputChange}" />
                ${this.hasSearchQuery
                  ? html`
                      <svg
                        style="cursor: pointer;"
                        @click=${this.clearSearchInput}
                        width="${svgSize}"
                        height="${svgSize}"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M6.22566 4.81096C5.83514 4.42044 5.20197 4.42044 4.81145 4.81096C4.42092 5.20148 4.42092 5.83465 4.81145 6.22517L10.5862 11.9999L4.81151 17.7746C4.42098 18.1651 4.42098 18.7983 4.81151 19.1888C5.20203 19.5793 5.8352 19.5793 6.22572 19.1888L12.0004 13.4141L17.7751 19.1888C18.1656 19.5793 18.7988 19.5793 19.1893 19.1888C19.5798 18.7983 19.5798 18.1651 19.1893 17.7746L13.4146 11.9999L19.1893 6.22517C19.5799 5.83465 19.5799 5.20148 19.1893 4.81096C18.7988 4.42044 18.1657 4.42044 17.7751 4.81096L12.0004 10.5857L6.22566 4.81096Z"
                            fill="${this.textColor}"
                          />
                        </g>
                      </svg>
                    `
                  : html`
                      <svg width="${svgSize}" height="${svgSize}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17.0392 15.6244C18.2714 14.084 19.0082 12.1301 19.0082 10.0041C19.0082 5.03127 14.9769 1 10.0041 1C5.03127 1 1 5.03127 1 10.0041C1 14.9769 5.03127 19.0082 10.0041 19.0082C12.1301 19.0082 14.084 18.2714 15.6244 17.0392L21.2921 22.707C21.6828 23.0977 22.3163 23.0977 22.707 22.707C23.0977 22.3163 23.0977 21.6828 22.707 21.2921L17.0392 15.6244ZM10.0041 17.0173C6.1308 17.0173 2.99087 13.8774 2.99087 10.0041C2.99087 6.1308 6.1308 2.99087 10.0041 2.99087C13.8774 2.99087 17.0173 6.1308 17.0173 10.0041C17.0173 13.8774 13.8774 17.0173 10.0041 17.0173Z"
                            fill="${this.textColor}"
                          ></path>
                        </g>
                      </svg>
                    `}
              </div>

              <div class="selected-contacts">
                ${this.selectedContacts.map(
                  contact => html`
                    <iso-chip
                      .imageSrc=${contact.userProfileImageUrl}
                      .label=${contact.userName}
                      bgColor="var(--bg-primary-color)"
                      textColor="var(--text-primary-color)"
                      labelColor="var(--text-primary-color)"
                      imageHeight="24px"
                      imageWidth="24px"
                      imageRadius="50%"
                      @click=${() => this.removeContact(contact)}
                    ></iso-chip>
                  `,
                )}
              </div>

              <div class="new-chat-tile-list" @scroll="${this.handleScroll}">
                ${
            this.isLoadingMemeber ? html`<spinner-loader height="15px" width="15px" spinTime="1s"  spinnerPrimaryColor="var(--bg-primary-color)" spinnerSecondaryColor="var(--text-primary-color)" spinnerBorderWidth="2px"></spinner-loader>` :
               !this.nonBlockedContacts?.length ?
                  html`<no-contacts-placeholder></no-contacts-placeholder>`
                    : html`
                      ${this.nonBlockedContacts.map(
                        contact => html`
                          <contact-tile
                            @click="${() => this.handleContactSelection(contact.userId, contact.userName)}"
                            bgColor="var(--bg-secondary-color)"
                            textColor="var(--text-primary-color)"
                            borderWidth="0px 0px 1px 0px"
                            borderColor="var(--bg-quaternary-color)"
                            borderStyle="solid"
                            padding="18px 10px"
                            height="auto"
                            width="100%"
                            imageSrc="${contact.userProfileImageUrl}"
                            contactName="${contact.userName}"
                            userId="${contact.userId}"
                            .isCheckBox=${false}
                          ></contact-tile>
                        `,
                      )}
                    `}
                ${this.isPaginationMember
                  ? html`<div class="loading-container">
                      <spinner-loader
                        height="15px"
                        width="15px"
                        spinTime="1s"
                        spinnerPrimaryColor="var(--bg-primary-color)"
                        spinnerSecondaryColor="var(--text-primary-color)"
                        spinnerBorderWidth="2px"
                      ></spinner-loader>
                    </div>`
                  : ''}
              </div>
            </div>
            ${this.isGroupCast
              ? html`
                  <button @click=${this.handleGroupCastClick} class="create-button ${this.selectedContacts.length > 0 ? 'show' : ''}" >
                    <svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="var(--text-primary-color)">
                      <path
                        d="M720-440v-80h160v80H720Zm48 280-128-96 48-64 128 96-48 64Zm-80-480-48-64 128-96 48 64-128 96ZM200-200v-160h-40q-33 0-56.5-23.5T80-440v-80q0-33 23.5-56.5T160-600h160l200-120v480L320-360h-40v160h-80Zm240-182v-196l-98 58H160v80h182l98 58Zm120 36v-268q27 24 43.5 58.5T620-480q0 41-16.5 75.5T560-346ZM300-480Z"
                      />
                    </svg>

                    ${WEB_CONTENT.CHAT.GROUP_CAST.CREATE_GROUP_CAST}
                  </button>
                `
              : html`
                  <button class="create-button ${this.selectedContacts.length > 0 ? 'show' : ''}" @click=${this.handleCreateClick}>
                    Add Members
                    <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px" fill="var(--text-primary-color)">
                      <path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" />
                    </svg>
                  </button>
                `}
          </div>
        `;
  }

  handleScroll(event) {
    const element = event.target;
    const threshold = 1;
    if ((element.scrollHeight - Math.round(element.scrollTop) <= element.clientHeight + threshold) && this.hasMoreMembers && !this.isPaginationMember) {
      this.isLoading = true;
      this.dispatchEvent(
        new CustomEvent('group-contacts-scrolled-to-bottom', {
          bubbles: true,
          composed: true,
        }),
      );
    }
  }


  clearSearchInput() {
    const searchInput = this.shadowRoot.querySelector('#search-input');
    if (searchInput) {
      searchInput.value = '';
      this.hasSearchText = false;

      // Dispatch an input event to trigger the search reset
      this.dispatchEvent(
        new CustomEvent('group-contacts-input-changed', {
          detail: { inputValue: '' },
          bubbles: true,
          composed: true,
        }),
      );
    }
  }

  handleInputChange(event) {
    const inputValue = event.target.value;
    this.hasSearchQuery = inputValue.length > 0;

    // Show loading state immediately when typing
    if (inputValue?.trim()?.length > 0) {
      this.isLoading = true;
    }

    clearTimeout(this.debounceTimeout);

    this.debounceTimeout = setTimeout(() => {
      // Dispatch the search event after debounce
      this.dispatchEvent(
        new CustomEvent('group-contacts-input-changed', {
          detail: {
            inputValue,
            isDebounced: true,
            selectedUserIds: this.selectedContacts.map(contact => contact.userId),
          },
          bubbles: true,
          composed: true,
        }),
      );
    }, this.DEBOUNCE_DELAY);

    // If input is cleared, immediately trigger search reset
    if (inputValue.trim() === '') {
      clearTimeout(this.debounceTimeout);
      this.isLoading = true;
      this.dispatchEvent(
        new CustomEvent('group-contacts-input-changed', {
          detail: {
            inputValue: '',
            isDebounced: false,
            selectedUserIds: this.selectedContacts.map(contact => contact.userId),
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  }

  handleContactSelection(userId, userName) {
    const contact = this.nonBlockedContacts.find(c => c.userId === userId);
    if (contact && !this.selectedContacts.some(c => c.userId === userId)) {
      this.selectedContacts = [...this.selectedContacts, contact];
      // Filter out the selected contact from nonBlockedContacts
      this.nonBlockedContacts = this.nonBlockedContacts.filter(c => c.userId !== userId);
    }
    const searchInput = this.shadowRoot.querySelector('#search-input');
    if (searchInput) {
      searchInput.value = '';
      this.hasSearchQuery = false;
    }
    this.dispatchEvent(
      new CustomEvent('group-contacts-input-changed', {
        detail: { inputValue: '' },
        bubbles: true,
        composed: true,
      }),
    );
  }

  removeContact(contactToRemove) {
    this.selectedContacts = this.selectedContacts.filter(contact => contact.userId !== contactToRemove.userId);
    // Add the removed contact back to nonBlockedContacts if it's not already there
    if (!this.nonBlockedContacts.some(c => c.userId === contactToRemove.userId)) {
      this.nonBlockedContacts = [...this.nonBlockedContacts, contactToRemove];
    }
  }

  handleCreateGroupClick() {
    this.dispatchEvent(
      new CustomEvent('create-group-clicked', {
        bubbles: true,
        composed: true,
      }),
    );
  }

  handleGroupCastClick() {
    const selectedUserIds = this.selectedContacts.map(contact => contact.userId);
    this.showGroupInfo = true;
    this.selectedUserIds = selectedUserIds;
    this.dispatchEvent(
     new CustomEvent('group-cast-selected-contacts', {
       detail: {selectedUserIds},
       composed: true, 
       bubbles: true,
     })
    )
 }

  handleCreateClick() {
    const selectedUserIds = this.selectedContacts.map(contact => contact.userId);
    this.showGroupInfo = true;
    this.selectedUserIds = selectedUserIds;
    this.requestUpdate();
  }

  closeGroupInfoOverlay() {
    this.showGroupInfo = false;
  }

  closeAll() {
    // Close group info overlay
    this.closeGroupInfoOverlay();

    // Dispatch event to close group chat contacts
    this.dispatchEvent(
      new CustomEvent('close-all-overlays', {
        bubbles: true,
        composed: true,
      }),
    );
  }
}

customElements.define('group-chat-contacts', GroupChatContacts);
